// External libraries
import React from 'react';
import { LoadingElement } from '@checkout/react-components';

// Internal modules
import { lazyLoader } from '@/lib';
import { SepaMandate } from './SepaMandate';

const LazySepaMandate = lazyLoader({
  loader: () => import('./SepaMandate'),
  loading: () => <LoadingElement />,
  name: 'sepa_mandate',
  render(loaded, props) {
    return <SepaMandate {...props} />;
  },
});

export { LazySepaMandate };
